import axios from "axios";

export function fetchUser() {
  return axios.post("/private/app-user");
}

export function updateUser(updatedValues) {
  const {
    lang = null,
    username = null,
    pushToken = null,
    assistantName = null,
    avatar = null,
    code = null,
    showWellbeingCheck = null,
    trackingAccepted = null,
  } = updatedValues;

  return axios.post("/private/app-user/update", {
    lang,
    username,
    pushToken,
    assistantName,
    avatar,
    code,
    showWellbeingCheck,
    trackingAccepted,
  });
}

export function sendPassword(
  email,
  firstname,
  lastname,
  code,
  agreedPrivacyPolicy,
  agreedTermsOfUse
) {
  const payload = {
    email,
    firstname,
    lastname,
    code,
    agreedPrivacyPolicy,
    agreedTermsOfUse,
  };

  return axios.post("/desktop/app-user/init", payload);
}

export function forgotPassword(email) {
  const payload = {
    email,
  };

  return axios.post("/app-user/password/reset", payload);
}

export function acceptPolicy(policyType) {
  const payload = {
    policyType,
  };

  return axios.post("/private/app-user/policy/accept", payload);
}

export function deleteProfile(password) {
  const payload = {
    password,
  };

  return axios.post("/private/app-user/delete", payload);
}

export function changePassword(oldPassword, newPassword1, newPassword2) {
  const payload = {
    oldPassword,
    newPassword1,
    newPassword2,
  };

  return axios.post("/private/app-user/password/change", payload);
}

export function viewedElement(key) {
  const payload = {
    key,
  };

  return axios.post("/app-user/element-viewed", payload);
}

export function getChallengeHistory(language) {
  return axios.post(
    "/challenge-history",
    {},
    {
      params: {
        lang: language,
      },
    }
  );
}
